import { matchPath } from "react-router-dom";

export const matchInteractPath = <T extends { [K in keyof T]?: string }>(path: string) =>
  matchPath<T>(window.location.pathname, {
    path,
    exact: true,
    strict: false,
  });
